import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-queue-pending-overlay',
  templateUrl: './queue-pending-overlay.component.html',
  styleUrls: ['./queue-pending-overlay.component.scss'],
  standalone: false
})
export class QueuePendingOverlayComponent {
  @Input() title = 'Operazione in coda';
  @Input() subtitle = 'Attendi conferma dal server';
  @Input() iconName = 'hourglass-outline';
}

